import React from 'react';
import { ClockIcon, CarIcon, UsersIcon, ShieldCheckIcon } from 'lucide-react';
export function StatsBar() {
  const stats = [{
    icon: <ClockIcon className="h-8 w-8" data-id="element-272" />,
    value: '97%',
    label: 'On-Time Arrivals'
  }, {
    icon: <CarIcon className="h-8 w-8" data-id="element-273" />,
    value: '5,000+',
    label: 'Successful Rides'
  }, {
    icon: <UsersIcon className="h-8 w-8" data-id="element-274" />,
    value: '200+',
    label: 'Recurring Patients'
  }, {
    icon: <ShieldCheckIcon className="h-8 w-8" data-id="element-275" />,
    value: '100%',
    label: 'Licensed & Insured'
  }];
  return <section className="bg-white py-12 border-t border-b border-gray-200" data-id="element-276">
      <div className="max-w-7xl mx-auto px-4" data-id="element-277">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-278">
          {stats.map((stat, index) => <div key={index} className="text-center" data-id="element-279">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-[#E63946] bg-opacity-10 rounded-full mb-4 text-[#E63946]" data-id="element-280">
                {stat.icon}
              </div>
              <div className="text-3xl lg:text-4xl font-bold text-[#0B1F3A] mb-2" data-id="element-281">
                {stat.value}
              </div>
              <div className="text-gray-600 font-medium" data-id="element-282">{stat.label}</div>
            </div>)}
        </div>
      </div>
    </section>;
}